import { useAppDispatch, useAppSelector } from "app/hooks";
import { getScores } from "app/reducers/scoresSlice";
import { fetchScores } from "app/thunks/scoresAPI";
import { useEffect, useState } from "react";
import { Title } from "ui";
import Spinner from "ui/Spinner";

import { ScoresTable } from "./ScoresTable";

export const MatchesScreen = () => {
  const dispatch = useAppDispatch();
  const scoresData = useAppSelector(getScores);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchScores());
      setLoading(false);
    };
    fetchData();
  }, [dispatch]);

  const lastMatchScores = (scoresData.scores.lastMatch || []).map(
    (score, index) => ({
      position: index + 1,
      alias: score.playerAlias,
      score: score.score,
    }),
  );

  while (lastMatchScores.length < 3) {
    lastMatchScores.push({
      position: lastMatchScores.length + 1,
      alias: "-",
      score: 0,
    });
  }

  const dailyScores = (scoresData.scores.daily || []).map((score, index) => ({
    position: index + 1,
    alias: score.playerAlias,
    score: score.score,
  }));

  const last30daysScores = (scoresData.scores.last30days || []).map(
    (score, index) => ({
      position: index + 1,
      alias: score.playerAlias,
      score: score.score,
    }),
  );

  const historicalScores = (scoresData.scores.historical || []).map(
    (score, index) => ({
      position: index + 1,
      alias: score.playerAlias,
      score: score.score,
    }),
  );

  return (
    <div className="flex flex-col justify-between w-full min-h-screen px-8 pb-8 bg-faux-dark-gunmetal pt-10">
      <Title text="Misión completada, tripulación!" className="mb-4" />
      {loading ? (
        <div className="flex justify-center items-center flex-1">
          <Spinner color="white" size={40} />
        </div>
      ) : (
        <div className="flex flex-col flex-1">
          <div className="m-6 flex justify-center items-center flex-1">
            <div className="flex w-full h-full">
              <div className="w-1/3 h-full">
                <ScoresTable
                  title="Resultados de la reciente Misión"
                  description="Quienes se animaron a formar parte de la batalla más reciente"
                  scores={lastMatchScores}
                  titleClassName="text-[18px] font-normal leading-[32.4px] tracking-[0.018em] text-left uppercase decoration-skip-ink-none"
                  descriptionClassName="text-[14px] italic font-normal leading-[25.2px] tracking-[0.018em] text-left decoration-skip-ink-none"
                  tableClassName="text-[18px] font-normal leading-[33.78px] tracking-[-0.006em] text-left decoration-skip-ink-none"
                  withGradientHeader={true}
                  gradientColors="linear-gradient(180deg, #7B1FA2 -54.74%, #292E33 99.63%)"
                />
              </div>
              <div className="w-2/3 h-full ml-6 flex flex-col">
                <div className="h-2/5 flex">
                  <div className="w-1/2 h-full">
                    <ScoresTable
                      title="Comandantes del Día"
                      description="Quienes demostraron mayor destreza en combate hoy"
                      scores={dailyScores}
                      maxPositions={3}
                      titleClassName="text-[16px] font-normal leading-[28.8px] tracking-[0.018em] text-left uppercase decoration-skip-ink-none"
                      descriptionClassName="text-[12px] italic font-normal leading-[21.6px] tracking-[0.018em] text-left decoration-skip-ink-none"
                      tableClassName="text-[16px] font-normal leading-[31.57px] tracking-[-0.006em] text-left decoration-skip-ink-none"
                    />
                  </div>
                  <div className="w-1/2 h-full ml-6">
                    <ScoresTable
                      title="Élite de la Flota mensual"
                      description="Quienes lideraron la lucha contra la invasión este mes"
                      scores={last30daysScores}
                      maxPositions={3}
                      titleClassName="text-[16px] font-normal leading-[28.8px] tracking-[0.018em] text-left uppercase decoration-skip-ink-none"
                      descriptionClassName="text-[12px] italic font-normal leading-[21.6px] tracking-[0.018em] text-left decoration-skip-ink-none"
                      tableClassName="text-[16px] font-normal leading-[31.57px] tracking-[-0.006em] text-left decoration-skip-ink-none"
                    />
                  </div>
                </div>
                <div className="h-3/5 mt-6">
                  <ScoresTable
                    title="Leyendas del Universo"
                    description="Los nombres que quedarán en la historia de la humanidad"
                    scores={historicalScores}
                    layout="columns"
                    titleClassName="text-[16px] font-normal leading-[28.8px] tracking-[0.018em] text-left uppercase decoration-skip-ink-none"
                    descriptionClassName="text-[14px] italic font-normal leading-[25.2px] tracking-[0.018em] text-left decoration-skip-ink-none"
                    tableClassName="text-[18px] font-normal leading-[31.57px] tracking-[-0.006em] text-left decoration-skip-ink-none"
                    withGradientHeader={true}
                    gradientColors="linear-gradient(180deg, #D1C4E9 -58.9%, #292E33 88.89%)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
